$.post( phptojs.wpAjaxUrl, {
	action: 'track_page_view',
	query: location.search
} );
